import * as types from './actionTypes'

export const exportPdf = (file, template, documents) => ({
    type: types.PDF_EXPORT,
    file,
    template,
    documents
})

export const exportPdfSuccess = () => ({
    type: types.PDF_EXPORT_SUCCESS
})

export const exportPdfFailed = () => ({
    type: types.PDF_EXPORT_FAILED
})

export const deletePdfTemplate = (id) => ({
    type: types.PDF_TEMPLATE_DELETE,
    id
})

export const deletePdfTemplateSuccess = () => ({
    type: types.PDF_TEMPLATE_DELETE_SUCCESS
})

export const deletePdfTemplateFailed = () => ({
    type: types.PDF_TEMPLATE_DELETE_FAILED
})

export const setPdfTemplatesOrder = (entity, order) => ({
    type: types.SET_PDF_TEMPLATES_ORDER,
    entity,
    order
})
